export default function UserAvatar({ user, size = 36, onClick }) {
  const initials = (user?.displayName || user?.username || '?').trim().slice(0, 1).toUpperCase();
  const interactive = typeof onClick === 'function';
  return (
    <div
      className="avatar"
      onClick={onClick}
      style={{
        width: size, height: size,
        fontSize: Math.max(11, size * 0.4),
        cursor: interactive ? 'pointer' : 'default'
      }}
    >
      {user?.avatarUrl ? <img src={user.avatarUrl} alt={user.displayName || user.username} /> : initials}
    </div>
  );
}
